import {
    Box,
    Chip,
    Grid,
    IconButton,
    InputBase,
    ListItemIcon,
    ListItemText,
    Pagination,
    Paper,
    Stack,
    Typography,
    useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTheme } from '@mui/styles';
import SubCard from 'ui-component/cards/SubCard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StyledDataGrid from 'ui-component/StyledDataGrid';
import axios from 'axios';
import ApiLink from 'API';
import { useNavigate } from 'react-router';
import NumberFormat from 'react-number-format';
import ViewInoicePreorder from 'views/managementPreorder/invoice/ViewInoicePreorder';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import moment from 'moment';
import { StyledMenu, StyledMenuItem } from 'ui-component/MenuPopup';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AssignmentReturnedIcon from '@mui/icons-material/AssignmentReturned';
import CardInvoice from './CardInvoice';
import ViewInoice from 'views/invoice/ViewInoice';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import SimpleBackdrop from 'ui-component/SimpleBackdrop';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SearchField from 'ui-component/SearchField';
import ViewQrPaymentDetail from 'views/financial/qrPayment/verifyQrPayment/ViewQrPaymentDetail';

const QR_TTL_MS = 24 * 60 * 60 * 1000; // BCEL QR is valid for 24h after issue

// Ticking countdown that recomputes once per second. Shows red when < 1h left.
const ApprovedCountdown = ({ updatedAt }) => {
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(id);
    }, []);
    const start = updatedAt ? new Date(updatedAt).getTime() : Date.now();
    const remaining = Math.max(0, start + QR_TTL_MS - now);
    const h = Math.floor(remaining / 3600000);
    const m = Math.floor((remaining % 3600000) / 60000);
    const s = Math.floor((remaining % 60000) / 1000);
    const expired = remaining === 0;
    const urgent = remaining < 3600000; // < 1h
    const color = expired ? '#c62828' : urgent ? '#f57224' : '#2e7d32';
    return (
        <Stack direction="row" spacing={0.5} alignItems="center">
            <AccessTimeIcon sx={{ fontSize: 14, color }} />
            <Typography variant="caption" sx={{ fontFamily: 'monospace', fontWeight: 700, color }}>
                {expired ? 'EXPIRED' : `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`}
            </Typography>
        </Stack>
    );
};
export const PreorderInvoice = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleCloseMore = () => {
        setAnchorEl(null);
    };
    const [openBackdrop, setopenBackdrop] = useState(false);
    const theme = useTheme();
    const [BillData, setBillData] = useState([]);
    const [totalPage, settotalPage] = useState(0);
    const [page, setpage] = useState(1);
    const [total, settotal] = useState(0);
    const navigate = useNavigate();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [ValueSearch, setValueSearch] = useState('');
    const [OpenInvoice, setOpenInvoice] = useState(false);
    const [SelectedData, setSelectedData] = useState({});
    const [OpenInvoiceComplete, setOpenInvoiceComplete] = useState(false);
    const [OpenQRDetail, setOpenQRDetail] = useState(false);
    const [SelectedQR, setSelectedQR] = useState({});

    const handlePage = (event, value) => {
        setpage(value);
    };
    // const columns = [
    //     // { field: '_id', headerName: 'id', width: 90 },
    //     {
    //         field: 'status',
    //         headerName: 'Status',
    //         width: 120,
    //         // flex: 0.5,
    //         // editable: true,
    //         headerAlign: 'center',
    //         align: 'center',
    //         renderCell: (params) => (
    //             // <Typography
    //             //     color={
    //             //         params.row.status === '0'
    //             //             ? 'red'
    //             //             : params.row.status === '1'
    //             //             ? 'primary'
    //             //             : params.row.status === '2'
    //             //             ? 'green'
    //             //             : 'silver'
    //             //     }
    //             //     variant="button"
    //             //     gutterBottom
    //             //     style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
    //             // >
    //             //     {params.row.status === '0'
    //             //         ? 'Order'
    //             //         : params.row.status === '1'
    //             //         ? 'Coming'
    //             //         : params.row.status === '2'
    //             //         ? 'Completed'
    //             //         : 'Reject'}
    //             // </Typography>
    //             <Chip
    //                 variant="outlined"
    //                 color={
    //                     params.row.status === '0'
    //                         ? 'error'
    //                         : params.row.status === '1'
    //                         ? 'info'
    //                         : params.row.status === '2'
    //                         ? 'success'
    //                         : 'default'
    //                 }
    //                 icon={
    //                     params.row.status === '0' ? (
    //                         <AssignmentReturnedIcon />
    //                     ) : params.row.status === '1' ? (
    //                         <LocalShippingIcon />
    //                     ) : params.row.status === '2' ? (
    //                         <CheckCircleOutlineIcon />
    //                     ) : (
    //                         <ThumbDownIcon />
    //                     )
    //                 }
    //                 label={
    //                     params.row.status === '0'
    //                         ? 'Order'
    //                         : params.row.status === '1'
    //                         ? 'Coming'
    //                         : params.row.status === '2'
    //                         ? 'Completed'
    //                         : 'Reject'
    //                 }
    //             />
    //         )
    //     },
    //     ,
    //     {
    //         field: 'invoiceRequest',
    //         headerName: 'Invoice Preorder',
    //         width: 200,
    //         // flex: 0.5,
    //         // editable: true,
    //         headerAlign: 'center',
    //         align: 'center',
    //         renderCell: (params) => (
    //             <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
    //                 {params.row.invoiceRequest}
    //             </Typography>
    //         )
    //     },
    //     // {
    //     //     field: 'paymentType',
    //     //     headerName: 'PaymentType',
    //     //     width: 120,
    //     //     // flex: 0.5,
    //     //     // editable: true,
    //     //     headerAlign: 'center',
    //     //     align: 'center',
    //     //     renderCell: (params) => (
    //     //         <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
    //     //             {params.row.paymentType}
    //     //         </Typography>
    //     //     )
    //     // },
    //     {
    //         field: 'totalPayment',
    //         headerName: 'Total',
    //         width: 150,
    //         // flex: 0.5,
    //         // editable: true,
    //         headerAlign: 'center',
    //         align: 'center',
    //         renderCell: (params) => (
    //             <Typography variant="body1" color="#f57224" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
    //                 <NumberFormat
    //                     thousandsGroupStyle="thousand"
    //                     value={params.row.totalPayment}
    //                     prefix="₭"
    //                     decimalSeparator="."
    //                     displayType="text"
    //                     type="text"
    //                     thousandSeparator={true}
    //                     allowNegative={true}
    //                 />
    //             </Typography>
    //         )
    //     },
    //     {
    //         field: 'customer',
    //         headerName: 'customer',
    //         width: 120,
    //         // flex: 0.5,
    //         // editable: true,
    //         headerAlign: 'center',
    //         align: 'center',
    //         renderCell: (params) => (
    //             <Stack>
    //                 <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
    //                     {params.row.customerID}
    //                 </Typography>
    //                 <Typography variant="caption" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
    //                     {params.row.customers.customerName}
    //                 </Typography>
    //             </Stack>
    //         )
    //     },
    //     {
    //         field: 'createdAt',
    //         headerName: 'Date',
    //         width: 200,
    //         // flex: 0.5,
    //         // editable: true,
    //         headerAlign: 'center',
    //         align: 'center',
    //         renderCell: (params) => {
    //             return (
    //                 <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
    //                     {moment(params.row.createdAt).format('DD-MM-yyyy HH:mm')}
    //                 </Typography>
    //             );
    //         }
    //     },
    //     // {
    //     //     field: 'saleBy',
    //     //     headerName: 'SaleBy',
    //     //     width: 200,
    //     //     // flex: 0.5,
    //     //     // editable: true,
    //     //     headerAlign: 'center',
    //     //     align: 'center',
    //     //     renderCell: (params) => (
    //     //         <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
    //     //             {params.row.saleBy}
    //     //         </Typography>
    //     //     )
    //     // },
    //     {
    //         field: 'action',
    //         headerName: 'Action',
    //         // flex: 0.5,
    //         width: 150,
    //         sortable: false,
    //         filterable: false,
    //         headerAlign: 'center',
    //         align: 'center',
    //         renderCell: (params) => (
    //             <Stack direction="row" spacing={1}>
    //                 <IconButton
    //                     // color="primary"
    //                     sx={{ color: '#0c4da2' }}
    //                     onClick={() => {
    //                         setSelectedData(params.row);
    //                         setOpenInvoice(true);
    //                     }}
    //                 >
    //                     <VisibilityIcon />
    //                 </IconButton>
    //             </Stack>
    //         )
    //         // editable: true
    //     }
    // ];
    async function LoadData(ValueFind) {
        try {
            setBillData([]);
            setopenBackdrop(true);
            const valueReplate = ValueFind === '' ? '^' : ValueFind.toLowerCase();

            const response = await axios.get(ApiLink + '/api/requestproduct/invoice/sale/' + valueReplate + '/' + page, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setBillData(response.data.data);
                settotal(response.data.total);
                settotalPage(response.data.totalPage);
                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
        }
    }
    const PreviewInvoice = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const Preview = await axios.get(ApiLink + '/api/aonewallet/invoice/' + Requestid, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (Preview.status === 200) {
                setSelectedData(Preview.data?.data);
                setOpenInvoiceComplete(true);
                // console.log(Preview.data.data);
                // const Content = await (<InvoicePDF data={Preview.data?.data} />);
                // MessageBox.open({
                //     title: 'Preview',
                //     content: Content,
                //     buttons: [{ name: 'Close', handler: () => true }]
                // });
            } else if (Preview.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            console.log(error);
        }
        setopenBackdrop(false);
    };
    useEffect(() => {
        LoadData(ValueSearch);
    }, []);
    useEffect(() => {
        LoadData(ValueSearch);
    }, [page]);

    return (
        <Grid container spacing={2}>
            <SimpleBackdrop open={openBackdrop} />
            <ViewInoicePreorder Open={OpenInvoice} setOpen={setOpenInvoice} DataInvoice={SelectedData} />
            <ViewInoice setOpen={setOpenInvoiceComplete} Open={OpenInvoiceComplete} DataInvoice={SelectedData} />
            <ViewQrPaymentDetail
                Open={OpenQRDetail}
                setOpen={setOpenQRDetail}
                SelectedData={SelectedQR}
                onUpdated={() => LoadData(ValueSearch)}
            />
            <Grid item xs={12}>
                <SubCard
                    title="Invoice List"
                    contentSX={{ p: 0 }}
                    show={true}
                    secondary={
                        <SearchField
                            value={ValueSearch}
                            onChange={setValueSearch}
                            onSearch={(v) => { setpage(1); LoadData(v); }}
                            onReset={() => { setpage(1); LoadData(''); }}
                            placeholder="Invoice Number"
                            disabled={openBackdrop}
                            width={matchDownSM ? 180 : 300}
                        />
                    }
                >
                    <Box
                        // style={{
                        //     width: '100%',
                        //     height: '80vh',
                        //     textAlign: 'center'
                        //     // overflow: "auto",
                        // }}
                        sx={{ width: '100%', height: '80vh', textAlign: 'center', border: 0, borderRadius: 16, overflow: 'auto' }}
                    >
                        {/* <StyledDataGrid
                            loading={openBackdrop}
                            getRowId={(row) => row._id}
                            rows={BillData}
                            columns={columns}
                            //pageSize={20}
                            rowHeight={100}
                            headerHeight={60}
                            hideFooter={true}
                        /> */}
                        {BillData.map((item) => {
                            return (
                                <CardInvoice
                                    BtnInvoice={item.status === '2' ? true : false}
                                    Head={
                                        <Box sx={{ padding: 2 }}>
                                            {item.status === '1' && item.qrPayment ? (
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Chip
                                                        variant="outlined"
                                                        color="info"
                                                        icon={<QrCode2Icon />}
                                                        label="View QR"
                                                        clickable
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedQR(item.qrPayment);
                                                            setOpenQRDetail(true);
                                                        }}
                                                    />
                                                    {item.qrPayment.status === 'approved' && (
                                                        <ApprovedCountdown
                                                            updatedAt={item.qrPayment.updatedAt || item.qrPayment.createdAt}
                                                        />
                                                    )}
                                                </Stack>
                                            ) : (
                                                <Chip
                                                    variant="outlined"
                                                    color={
                                                        item.status === '0'
                                                            ? 'error'
                                                            : item.status === '1'
                                                                ? 'info'
                                                                : item.status === '2'
                                                                    ? 'success'
                                                                    : 'default'
                                                    }
                                                    icon={
                                                        item.status === '0' ? (
                                                            <AssignmentReturnedIcon />
                                                        ) : item.status === '1' ? (
                                                            <QrCode2Icon />
                                                        ) : item.status === '2' ? (
                                                            <CheckCircleOutlineIcon />
                                                        ) : item.status === 'pending' ? (
                                                            <HourglassBottomIcon />
                                                        ) : (
                                                            <ThumbDownIcon />
                                                        )
                                                    }
                                                    label={
                                                        item.status === '0'
                                                            ? 'Order'
                                                            : item.status === '1'
                                                                ? 'QR Payment'
                                                                : item.status === '2'
                                                                    ? 'Completed'
                                                                    : item.status === 'pending'
                                                                        ? 'Pending'
                                                                        : 'Reject'
                                                    }
                                                />
                                            )}
                                        </Box>
                                    }
                                    Body={
                                        <>
                                            <Stack>
                                                {/* <Typography variant="subtitle1">{item.invoiceRequest}</Typography>
                                                <Typography variant="caption">{'(' + item.model + ')'}</Typography> */}
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">Invoice:</Typography>
                                                    <Typography
                                                        variant="body2"
                                                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                                    >
                                                        {item.invoiceRequest}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">Customer:</Typography>
                                                    <Typography
                                                        variant="body2"
                                                        gutterBottom
                                                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                                    >
                                                        {item.customers?.customerName}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">CustomerID:</Typography>
                                                    <Typography
                                                        variant="body2"
                                                        gutterBottom
                                                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                                    >
                                                        {item.customerID}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">Date:</Typography>
                                                    <Typography
                                                        variant="body2"
                                                        gutterBottom
                                                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}
                                                    >
                                                        {moment(new Date(item.createdAt)).format('DD-MM-yyyy HH:mm')}
                                                    </Typography>
                                                </Stack>
                                                <Stack direction="row" spacing={1}>
                                                    <Typography variant="caption">{`Total:`}</Typography>
                                                    <Typography variant="body1" color="#f57224">
                                                        <NumberFormat
                                                            thousandsGroupStyle="thousand"
                                                            value={item.totalPayment}
                                                            prefix="₭"
                                                            decimalSeparator="."
                                                            displayType="text"
                                                            type="text"
                                                            thousandSeparator={true}
                                                            allowNegative={true}
                                                        />
                                                    </Typography>
                                                </Stack>
                                            </Stack>
                                        </>
                                    }
                                    OnClickViewInvoice={() => {
                                        //console.log(item);
                                        PreviewInvoice(item.invoiceRequest);
                                    }}
                                    OnClickView={() => {
                                        setSelectedData(item);
                                        setOpenInvoice(true);
                                    }}
                                />
                            );
                        })}
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '5px'
                        }}
                    >
                        <Pagination
                            disabled={openBackdrop}
                            count={totalPage}
                            // variant="outlined"
                            page={page}
                            size="small"
                            shape="rounded"
                            color="primary"
                            onChange={handlePage}
                            showFirstButton
                            showLastButton
                        />
                    </Box>
                    <p
                        style={{
                            fontSize: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '5px'
                        }}
                    >
                        Total : {total}
                    </p>
                </SubCard>
            </Grid>
        </Grid>
    );
};
